import { render, staticRenderFns } from "./BlockEditorQuote.vue?vue&type=template&id=2119157b&"
import script from "./BlockEditorQuote.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorQuote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports